<script lang="ts">
    import Container from "./Container.svelte";
    import Gap from "./Gap.svelte";
</script>

<Container small>
    <Gap height="4rem" />
    <div class="button-row">
        <slot />
    </div>
</Container>

<div class="content-box" />

<style lang="scss">
    @import "../vars.scss";
    .button-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2em;
        width: 100%;
    }
</style>
